export default class extends HTMLElement {
  connectedCallback () {
    this.details = this.querySelector('details')
    this.menu = this.querySelector('.dropdown-content')
    this.summary = this.querySelector('summary')

    if (!this.details || !this.menu || !this.summary) return

    // Move the menu to the body to escape overflow:hidden
    document.body.appendChild(this.menu)
    this.menu.style.display = 'none'
    this.menu.classList.add('teleported-dropdown-menu')

    this.toggleHandler = (e) => {
      const isOpen = this.details.hasAttribute('open')

      if (isOpen) {
        document.dispatchEvent(new CustomEvent('close-teleport-dropdowns', { detail: { except: this } }))

        const rect = this.summary.getBoundingClientRect()
        this.menu.style.display = 'flex'
        this.menu.style.position = 'fixed'

        // Position it perfectly below the kebab button
        this.menu.style.top = `${rect.bottom + 5}px`

        // Align the right edge of the menu with the right edge of the summary
        // Fallback to 166px width if offsetWidth is 0 during initial render
        const menuWidth = this.menu.offsetWidth || 166
        this.menu.style.left = `${rect.right - menuWidth + 4}px`
        this.menu.style.zIndex = '99999'
      } else {
        this.menu.style.display = 'none'
      }
    }

    this.details.addEventListener('toggle', this.toggleHandler)

    this.closeOthersHandler = (e) => {
      if (e.detail.except !== this) {
        this.details.removeAttribute('open')
        this.menu.style.display = 'none'
      }
    }
    document.addEventListener('close-teleport-dropdowns', this.closeOthersHandler)

    // Close when clicking anywhere outside the details or the teleported menu
    this.outsideClickHandler = (e) => {
      if (!this.details.contains(e.target) && !this.menu.contains(e.target)) {
        this.details.removeAttribute('open')
        this.menu.style.display = 'none'
      }
    }
    document.addEventListener('click', this.outsideClickHandler)

    // Close the menu if the user scrolls the page or the inner container
    this.scrollHandler = (e) => {
      if (this.details.hasAttribute('open')) {
        this.details.removeAttribute('open')
        this.menu.style.display = 'none'
      }
    }
    document.addEventListener('scroll', this.scrollHandler, true)

    this.details.classList.add('teleport-source')
  }

  disconnectedCallback () {
    this.details?.removeEventListener('toggle', this.toggleHandler)
    document.removeEventListener('close-teleport-dropdowns', this.closeOthersHandler)
    document.removeEventListener('click', this.outsideClickHandler)
    document.removeEventListener('scroll', this.scrollHandler, true)
    this.menu?.remove()
  }
}
